/**
 * Composes ACP client callbacks that forward to the bridge and record file changes.
 */

import type { AcpClientOptions } from '../clients/acp-client.js';
import type { AcpBridgeHooksOptions } from './acp-bridge-types.js';
import { createBridgeOnFileChange } from './bridge-on-file-change.js';
import { createBridgeOnRequest } from './bridge-on-request.js';
import { createBridgeOnSessionUpdate } from './bridge-on-session-update/index.js';

export type { AcpBridgeHooksOptions } from './acp-bridge-types.js';

export function buildAcpSessionBridgeHooks(opts: AcpBridgeHooksOptions): Pick<
  AcpClientOptions,
  'onFileChange' | 'onSessionUpdate' | 'onRequest'
> {
  const transcriptStreamSeqByRunId = new Map<string, number>();
  const nextTranscriptStreamSeq = (runId: string): number => {
    const n = (transcriptStreamSeqByRunId.get(runId) ?? 0) + 1;
    transcriptStreamSeqByRunId.set(runId, n);
    return n;
  };
  const optsWithSeq: AcpBridgeHooksOptions = { ...opts, nextTranscriptStreamSeq };

  return {
    onFileChange: createBridgeOnFileChange(optsWithSeq),
    onSessionUpdate: createBridgeOnSessionUpdate(optsWithSeq),
    onRequest: createBridgeOnRequest(optsWithSeq),
  };
}
